import mixpanel from 'mixpanel-browser';
import { FullStory } from '@fullstory/browser';
import posthog from 'posthog-js';

export const resetMixpanel = () => {
	mixpanel.reset();
};

export const setMixpanelIdentify = (userId) => {
	try { mixpanel.identify(userId); } catch (e) { /* swallow */ }
	try { posthog.identify(userId); } catch (e) { /* swallow */ }
};

// Keep old export as a pass-through so existing callers aren't broken
export const setMixpanelAlias = setMixpanelIdentify;

// Real Mixpanel alias: links a new canonical id (newId) to an EXISTING
// distinct_id (existingId), merging their event histories into one profile.
// Used at signup to merge the pre-auth trial identity (distinct_id = the email
// the user forwarded from) into the authenticated user (uid). Distinct from
// setMixpanelAlias above, which is only an identify() pass-through.
export const aliasMixpanel = (newId, existingId) => {
	try { mixpanel.alias(newId, existingId); } catch (e) { /* swallow */ }
};

export const recordEvent = (name, fields) => {
	try { mixpanel.track(name, fields); } catch (e) { /* swallow */ }
	try { FullStory.event(name, fields); } catch (e) { /* swallow */ }
	try { posthog.capture(name, fields); } catch (e) { /* swallow */ }
};

// Set persistent super properties that auto-attach to every subsequent event.
// Use for session-wide context (e.g. auth_method, flow_version).
export const registerSuperProperties = (props) => {
	try { mixpanel.register(props); } catch (e) { /* swallow */ }
	try { posthog.register(props); } catch (e) { /* swallow */ }
};

// Write to the Mixpanel People profile so milestones are queryable in cohorts.
export const setPeopleProperties = (props) => {
	try { mixpanel.people.set(props); } catch (e) { /* swallow */ }
};

// Each SDK is guarded independently so a failure in one (e.g. ad-blocker) doesn't skip the others.
// Caller treats this as fire-and-forget; never let it throw to the auth listener.
export const mixpanelSetup = (email, name, userId) => {
	try {
		mixpanel.identify(userId);
		mixpanel.people.set({ $email: email, $name: name });
	} catch (e) { /* swallow */ }
	try {
		FullStory.identify(userId, { email, name });
	} catch (e) { /* swallow */ }
	try {
		posthog.identify(userId, { email, name });
	} catch (e) { /* swallow */ }
};

